import React from "react";

function Footer() {
    return (
        <footer className="w-full bg-white border-t border-gray-200 py-2 text-center">
            <div className="w-full">
                <img
                    src="/footer.png" // Make sure this path is correct
                    alt="Footer Banner"
                    className="w-full h-auto max-h-[150px] mx-auto"
                />
                <p className="text-sm text-gray-500 mt-2">
                    Powered by <span className="font-semibold text-gray-700">Aarya Infosolutions</span>
                </p>
            </div>
        </footer>
    );
}

export default Footer;
